import PhaseSixIcon from "../../../basic/phaseSixIcon/PhaseSixIcon";
import { copyTextToClipboard } from "../../../helpers/clipboardHelpers";

interface ClassLinkCopyButtonProps {
    "data-testid"?: string;
    ariaLabel: string;
    /** Scheme-less URL shown on screen; copying uses copyUrl. */
    displayUrl: string;
    copyUrl: string;
    onCopied: () => void;
    onCopyFailed: () => void;
    className?: string;
    urlClassName?: string;
    urlTestid?: string;
}

/** The class link with a copy-on-click affordance. */
const ClassLinkCopyButton = (props: ClassLinkCopyButtonProps) => {
    const handleClick = () => {
        copyTextToClipboard(props.copyUrl).then((copied) => (copied ? props.onCopied() : props.onCopyFailed()));
    };

    return (
        <button
            type="button"
            data-testid={props["data-testid"]}
            aria-label={props.ariaLabel}
            onClick={handleClick}
            className={`flex items-center gap-xs bg-transparent border-none p-0 cursor-pointer ${
                props.className ?? ""
            }`}
        >
            <span
                data-testid={props.urlTestid}
                className={`text-s text-p6-grey-mid break-all text-left ${props.urlClassName ?? ""}`}
            >
                {props.displayUrl}
            </span>
            <PhaseSixIcon
                name="duplicate"
                className="text-xl text-p6-grey-mid shrink-0"
            />
        </button>
    );
};

export default ClassLinkCopyButton;
